import { FetchClient, DefaultRuntime, onRuntimeCreate, } from "@pnp/common";
export var emptyGuid = "00000000-0000-0000-0000-000000000000";
onRuntimeCreate(function (runtime) {
    var existing = runtime.get("sp");
    var spPart = Object.assign({}, {
        fetchClientFactory: function () { return new FetchClient(); },
    }, existing);
    runtime.assign({ sp: spPart });
});
export function setup(config, runtime) {
    if (runtime === void 0) { runtime = DefaultRuntime; }
    runtime.assign(config);
}
//# sourceMappingURL=splibconfig.js.map